import { render, staticRenderFns } from "./ButtonBulkTransferArticles.vue?vue&type=template&id=5398e9e0"
import script from "./ButtonBulkTransferArticles.vue?vue&type=script&lang=ts"
export * from "./ButtonBulkTransferArticles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports